import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box
} from '@mui/material';

interface JSONTableProps {
  data: string;
  title: string;
}

const JSONTable: React.FC<JSONTableProps> = ({ data, title }) => {
  let parsedData: Record<string, any> = {};
  
  // Check if data exists and is not empty
  if (!data || data.trim() === '' || data.trim() === '{}') {
    return (
      <Box p={2}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography color="text.secondary">
          No pricing data available
        </Typography>
      </Box>
    );
  }
  
  try {
    parsedData = JSON.parse(data);
  } catch (error) {
    return (
      <Box p={2}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography color="text.secondary">
          No pricing data available
        </Typography>
      </Box>
    );
  }

  const entries = Object.entries(parsedData);
  
  if (entries.length === 0) {
    return (
      <Box p={2}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography color="text.secondary">
          No pricing data available
        </Typography>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        {title}
      </Typography>
      
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Field</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.map(([key, value]) => (
              <TableRow key={key}>
                <TableCell sx={{ fontWeight: 500 }}>
                  {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                </TableCell>
                <TableCell>
                  {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default JSONTable;